<!-- components/Toast.vue -->
<template>
  <transition name="slide-fade">
    <div v-if="isVisible" :class="['toast', type]">
      <p class="text-white">{{ message }}</p>
    </div>
  </transition>
</template>

<script setup>
import { useToast } from "@/composables/useToast";

const { isVisible, message, type } = useToast();
</script>

<style scoped>
.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  color: white;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  max-width: 90%;
  text-align: center;
  opacity: 0.95;
}
.toast.success {
  background-color: #10b981; /* green */
}
.toast.error {
  background-color: #ef4444; /* red */
}
.toast.info {
  background-color: #3b82f6; /* blue */
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px); /* Antes era 20px positivo */
}
</style>
